import {useEffect} from 'react';

const OLD_BRAND='Elite Sales &Automation';
const NEW_BRAND='Elite Sales & Automation';

export default function BrandSpacingFix() {
  useEffect(()=> {
    const replaceBrandSpacing=()=> {
      const walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT);
      const textNodes=[];
      let node=walker.nextNode();

      while (node) {
        if (node.nodeValue?.includes(OLD_BRAND)) {
          textNodes.push(node);
        }
        node=walker.nextNode();
      }

      textNodes.forEach((textNode)=> {
        textNode.nodeValue=textNode.nodeValue.replaceAll(OLD_BRAND,NEW_BRAND);
      });

      if (document.title.includes(OLD_BRAND)) {
        document.title=document.title.replaceAll(OLD_BRAND,NEW_BRAND);
      }
    };

    replaceBrandSpacing();

    const observer=new MutationObserver(replaceBrandSpacing);
    observer.observe(document.body,{childList: true,subtree: true});

    return ()=> observer.disconnect();
  },[]);

  return null;
}